<template>
  <div class="calendar_right">
    <div class="PreviewWrap">
      <!-- 预览标题 -->
      <div class="PreviewTop">
        <div class="Previewleft">
          <div :class="['PreviewType',{'PreviewTypeScte': NewLiveStatus.status == 3}]">
            {{NewLiveStatus.status == 0 ? 'End' :NewLiveStatus.statusValue}}
          </div>
          <div class="PreviewTitle">
            {{NewLiveStatus.status == 0 ? '' :NewLiveStatus.title}}
          </div>
        </div>
        <div class="PreviewRight">
          <div class="passthroughBlocker" v-if="passthroughBlockShow">
          <!-- {{$t('lang.passthroughBlockerOn')}} -->
            <img src="@/assets/img/mark.png" alt="">
          </div>
          <div class="AudioOutput" v-if="OutputAudio.OutputAudioMute">
            <span class="title" :class="{'DisabledTitle': CloneDisabled.disableButton}">{{ $t('lang.OutputAudio') }}</span>
            <span
              v-if="OutputAudio.Loading"
              class="pushingIcon"
            >
              <i class="el-icon-loading" />
            </span>
            <el-switch :disabled="CloneDisabled.Output||CloneDisabled.disableButton" v-show="!OutputAudio.Loading" v-model="OutputAudio.switch" active-color="#13ce66" @change="OutputAudioMute" inactive-color="#666666"></el-switch>
          </div>
          <!-- 图标 -->
          <div class="IconWrap">
            <div v-if="NewLiveStatus.status">
              <!-- D图标 -->
                <p class="DCopyIcon" v-if="NewLiveStatus.copy == 'true'">
                  <i
                    class="iconfont icon-duplicate1"></i>
                </p>
                <!-- cc图标 -->
                <p class="CCIcon">
                  <i
                    class="iconfont icon-cc"></i>
                </p>
                <!-- R图标 -->
                <p class="RcordIcon">
                  <i
                    :class="['iconfont', NewLiveStatus.record ? 'icon-secondaryrecord':'icon-secondaryrecordoff']"></i>
                </p>
                <!-- s图标 -->
                <p class="SCTEIcon">
                  <i
                    class="iconfont icon-SCTEoff"></i>
                </p>
            </div>
          </div>
          <!-- 刷新 -->
          <div class="restart" v-repeat-click="{ delay: 200, event: restartWebRtc }">
            <i class="iconfont icon-refresh"></i>
            <div class="RestartTip">
              {{ $t('lang.Restart') }}
            </div>
          </div>
        </div>
      </div>
      <!-- 预览视频 -->
      <div class="video" style="position: relative">
        <!-- .cc字幕标识 -->
        <div v-if='transcriberStatus.transcriberShow&&transcriberStatus.isOpenFeature&&NewLiveStatus.status!=0'>
            <el-tooltip class="item" effect="dark" :content="$t('lang.transcriberRunning')" placement="bottom">
              <!-- <span class="circle"></span>  -->
              <span class="openTranscriber">·cc</span>
            </el-tooltip>
        </div>
        <!-- buffer 标识 -->
        <div v-if='bufferMessage.status'>
          <span class="buffer">·{{bufferMessage.bufferSize}}s Buffer</span>
        </div>
        <!-- 视频 -->
        <video id="videoMp4" :style="StyleMessage" ref="videoMp4" autoplay></video>
        <!-- 音量柱 -->
        <div class="rightVolume">
          <volumeBarItem :audiocontextObj="audiocontextObj" :autoplayOff='autoplayOff' @audioDialogOpen='audioDialogOpen'></volumeBarItem>
          <!-- <iframe :src="broadcastUrl" :style="StyleMessage"  class="singularIframe" frameborder="0"></iframe> -->
          <div class="audioOperate">
            <i @click="changeIconStatus(2)" :class="['iconfont', video2Muted ? 'icon-volume_off' : 'icon-volume-up']"></i>
            <el-dropdown trigger="click" >
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="volume">
                <el-dropdown-item :icon="Audiorecording[$BehaviorSyns.getProgramId()]?'el-icon-check':'el-icon-close'" @click.native="changeAudioType(1)">{{$t('lang.AutoplayOn')}}</el-dropdown-item>
                <el-dropdown-item :icon="!Audiorecording[$BehaviorSyns.getProgramId()]?'el-icon-check':'el-icon-close'" @click.native="changeAudioType(0)">{{$t('lang.AutoplayOff')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
      </div>
    </div>
    <!-- 下面的按钮操作 -->
    <div class="ButtonOperation">
      <el-button :disabled="CloneDisabled.SpotCoverOn||CloneDisabled.disableButton" class="Btn"  :title="ShortcutText.TakeBreakingSource" style="width: 140px"  @click="playSource" :loading='takeBreakSourceLoading' >{{ $t('lang.takeBreakSource') }}</el-button>
      <el-button :disabled="CloneDisabled.SpotCoverOn||CloneDisabled.disableButton" class="Btn"  :title="ShortcutText.TakePlaylist" style="width: 95px;" :loading='takePlayListLoading' @click="stopSource">{{ $t('lang.takePlayList') }}</el-button>
      <el-button :disabled="CloneDisabled.SpotCoverOn||CloneDisabled.disableButton" class="Btn"  :title="ShortcutText.TakeNext" style="width: 80px;" @click="takeNextEvent" :loading='takeNextLoading'>{{ $t('lang.takeNext') }}</el-button>
      <el-button :disabled="CloneDisabled.SpotCoverOn||CloneDisabled.disableButton" class="Btn"  :title="ShortcutText.EmergencySwitch" style="width: 120px;" :loading='emergencySwitchLoading' @click="emergencySwitch">{{ $t('lang.emergencySwitch') }}</el-button>
      <i class="iconfont icon-settings_btnCopy" :disabled="CloneDisabled.disableButton" @click="emergencySetting"></i>
    </div>
    <!-- 紧急视频设置 -->
    <emergency-setting v-if="emergencySettingMess.show" :emergencySettingMess="emergencySettingMess"  ></emergency-setting>
    <div class="OverlayInfo">
      <overlay-info ref="ScteOverlayInfo" :transcriberStatus='transcriberStatus'/>
    </div>
    <!-- 打开音量柱弹框提示 -->
    <audio-autoplay-policy v-if="audioAutoplay.show" :audioAutoplay='audioAutoplay' @openAudio='openAudio'></audio-autoplay-policy>
  </div>
</template>
<script>
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import OverlayInfo from './OverLay/index.vue'
import EmergencySetting from './common/emergencySetting.vue'
import volumeBarItem from '@/components/common/volumeBarItem.vue'
import CreatAudioContext from '@/assets/js/common/audioContext'
import audioAutoplayPolicy from './common/audioAutoplayPolicy.vue'
import { ShortcutText } from '@/assets/js/common/ParamConfig.js'
export default {
  components: {
    OverlayInfo,
    EmergencySetting,
    volumeBarItem,
    audioAutoplayPolicy
  },
  data () {
    return {
      // 计时为0关闭拿取scte的websocket
      CountDownScte: 20,
      active: {
        facial: 'all'
      },
      videoShow: true,
      playerOptions: {
        // 视频配置
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'es',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4', // 播放视频格式
            src: 'XXXXXXXXXXXXXXXXXXXXXXX' // url地址
            // src: "" //url地址
          }
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      tinr: null,
      // 字幕开关
      ccOutFlag: false,
      // 是否静音
      video2Muted: true,
      getWebrtc: null,
      // R的信息
      fixedDevice: {},
      // 当前直播流的状态
      NewLiveStatus: {
        status: 0
      },
      // 预览的宽高
      StyleMessage: {
        width: '400px',
        height: '228px'
      },
      // transcriber状态
      transcriberStatus: {
        // CC标识
        transcriberShow: false,
        // 是否自动
        isAuto: false,
        // feature开关
        isOpenFeature: false,
        // CC开关
        setOn: false
      },
      // 紧急播放信息
      emergencySettingMess: {
        show: false
      },
      audiocontextObj: null,
      // passthroughBlock开关
      passthroughBlockShow: false,
      // 音量柱弹框信息
      audioAutoplay: {
        show: false
      },
      takeBreakSourceLoading: false,
      takePlayListLoading: false,
      takeNextLoading: false,
      emergencySwitchLoading: false,
      // 快捷键控制
      ShortcutKey: {
        66: false,
        84: false,
        80: false,
        69: false,
        83: false,
        76: false,
        67: false
      },
      Audiorecording: JSON.parse(localStorage.getItem('Audiorecording')) || {},
      autoplayOff: false,
      previewId: '',
      // 快捷键配置
      ShortcutText: ShortcutText,
      // 输出开关loading
      OutputAudio: {
        OutputAudioMute: false, // 输出feature
        switch: false, // 是否打开
        Loading: false // 加载
      },
      // buffer信息
      bufferMessage: {
        status: 0,
        bufferSize: 2
      }
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      GetKernelStateObj: (state) => state.GetKernelStateObj,
      pageRequest: (state) => state.websocket.pageRequest,
      pageRWebsocket: (state) => state.websocket.pageRWebsocket,
      pageSerBusRequest: (state) => state.websocket.pageSerBusRequest,
      WSGetFacility: (state) => state.playout.WSGetFacility,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      listFeatures: (state) => state.playout.listFeatures
    })
  },
  watch: {
    // 行为同步
    'State.BehaviorChange' (data) {
      console.log('pla-right')
      if (data.action == 'playoutPreviewStatusModule') {
        // data.status == 0 表示结束
        if (data.status == 0) {
          if (data.eventId) {
            if (this.NewLiveStatus.eventId == data.eventId) {
              this.NewLiveStatus = data
            }
          } else {
            this.NewLiveStatus = data
          }
        } else {
          this.NewLiveStatus = data
        }
      }
    },
    listFeatures: {
      handler (val) {
        if (val.includes('transcriber')) {
          this.transcriberStatus.isOpenFeature = true
        }
        // 是否开启输出静音
        this.OutputAudio.OutputAudioMute = val.includes('OutputAudioMute')

        if (val.includes('shortcutKey')) {
          window.addEventListener('keydown', this.monitorDownKey)
          window.addEventListener('keyup', this.monitorUpKey)
          window.addEventListener('focus', this.PageFocus)
        }
      }
    }

  },
  created () {
    Bus.$on('getWebrtc', (x) => {
      this.previewVideo(x)
    })
    Bus.$on('passthroughBlockOpen', (status) => {
      this.passthroughBlockShow = status
    })
    Bus.$on('breakSourceLoading', (status) => {
      this.takeBreakSourceLoading = status
    })
    Bus.$on('playListLoading', (status) => {
      this.takePlayListLoading = status
    })
    Bus.$on('nextLoading', (status) => {
      this.takeNextLoading = status
    })
    Bus.$on('getWebrtcId', (data) => {
      this.previewId = data.peerId
    })
    Bus.$on('bufferMessage', (result) => {
      this.bufferMessage.bufferSize = result.bufferSize
    })
    // 获取预览状态
    this.getPreviewStatus()
    // 获取Transcriber状态
    this.getTranscriber()
    // 获取输出音频
    this.getOutputAudio()
    // 获取buffer状态
    this.getOutputBuffer()
  },
  mounted () {
    // 监听r改变
    Bus.$on('playOutVideoR', (item) => {
      this.fixedDevice = item
      this.audiocontextObj = new CreatAudioContext()
    })

    if (!this.pageSerBusRequest) {
      this.$createWebsocket.pageSerBusRequest()
    }
    this.WebpageWidthChange()
  },
  methods: {
    // 输出音频静音
    OutputAudioMute () {
      const outputAudioMute = this.OutputAudio.switch ? 0 : 1
      if (!this.OutputAudio.switch) {
        this.$confirm(this.$t('lang.OutputMute'), '', {
          confirmButtonText: this.$t('lang.Confirm'),
          cancelButtonText: this.$t('lang.cancel')
        }).then(() => {
          this.setOutputAudioMute(outputAudioMute)
        }).catch(() => {
          this.OutputAudio.switch = !this.OutputAudio.switch
        })
      } else {
        this.setOutputAudioMute(outputAudioMute)
      }
    },
    setOutputAudioMute (outputAudioMute) {
      this.OutputAudio.Loading = true
      this.axios
        .post(Outil.getUrl('/advance-setting/schedule/setOutputAudioMute'), {
          programId: this.$BehaviorSyns.getProgramId(),
          outputAudioMute: outputAudioMute
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.OutputAudio.switch = !res.data.result
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
            this.OutputAudio.switch = !this.OutputAudio.switch
          }
          this.OutputAudio.Loading = false
        }).catch(() => {
          this.OutputAudio.Loading = false
          this.OutputAudio.switch = !this.OutputAudio.switch
        })
    },
    // 获取输出音频
    getOutputAudio () {
      this.axios
        .post(Outil.getUrl('/advance-setting/schedule/getOutputAudioMute'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.OutputAudio.switch = !res.data.result
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    getOutputBuffer () {
      this.axios.post(Outil.getUrl('/outputBuffer/getOutputBufferByProgramId'),
        { programId: this.$BehaviorSyns.getProgramId() }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          this.bufferMessage = result
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 键盘down
    monitorDownKey (e) {
      if (e.ctrlKey && e.keyCode == 66) {
        // Take Breaking Source - “CTL-B”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.playSource()
      } else if (e.altKey && e.keyCode == 84) {
        // Take Next - “Alt-T”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.takeNextEvent()
      } else if (e.ctrlKey && e.keyCode == 80) {
        // Take Playlist - “CTL-P”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.stopSource()
      } else if (e.ctrlKey && e.keyCode == 69) {
        // Emergency Switch - “CTL-E”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.emergencySwitch()
      } else if (e.ctrlKey && e.keyCode == 83) {
        // SCTE Break Trigger - “CTL-S”  待完成
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.$refs.ScteOverlayInfo.$emit('LogoCrawlScteShortcut', 'Scte')
      } else if (e.ctrlKey && e.keyCode == 76) {
        // Logo “CTL-L”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.$refs.ScteOverlayInfo.$emit('LogoCrawlScteShortcut', 'Logo')
      } else if (e.altKey && e.keyCode == 67) {
        // Crawl “Alt-C”
        e.preventDefault()
        if (this.ShortcutKey[e.keyCode]) return
        this.ShortcutKey[e.keyCode] = true
        this.$refs.ScteOverlayInfo.$emit('LogoCrawlScteShortcut', 'Crawl')
      }
    },
    // 键盘up
    monitorUpKey (e) {
      if (e.keyCode == 66 || e.keyCode == 84 || e.keyCode == 80 || e.keyCode == 69 || e.keyCode == 83 || e.keyCode == 76 || e.keyCode == 67) {
        this.ShortcutKey[e.keyCode] = false
      }
    },
    changeAudioType (type) {
      const programId = this.$BehaviorSyns.getProgramId()
      this.Audiorecording[programId] = type
      localStorage.setItem('Audiorecording', JSON.stringify(this.Audiorecording))
      if (type) {
        this.audiocontextObj.resumeAudioBar()
        this.autoplayOff = false
      } else {
        this.autoplayOff = true
      }
    },
    // 页面聚焦
    PageFocus () {
      Object.keys(this.ShortcutKey).forEach((key) => {
        this.ShortcutKey[key] = false
      })
    },
    // 音量柱弹框打开
    audioDialogOpen () {
      const Audiorecording = JSON.parse(localStorage.getItem('Audiorecording')) || {}
      const programId = this.$BehaviorSyns.getProgramId()
      if (Audiorecording[programId]) {
        this.audioAutoplay.show = true
      }
    },
    // 音量柱弹框关闭触发音量柱显示音量
    openAudio () {
      this.audioAutoplay.show = false
      this.audiocontextObj.resumeAudioBar()
    },
    // 监听屏幕宽度变化
    WebpageWidthChange () {
      const $this = this
      $this.controlVideoWidth($this)
      $(window).resize(() => {
        $this.controlVideoWidth($this)
      })
    },
    // 控制视频宽度变化
    controlVideoWidth ($this) {
      const docWidth = document.body.clientWidth
      let videoWidth = 400
      if (docWidth > 1680) {
        videoWidth = 400
      } else if (docWidth > 1480 && docWidth <= 1680) {
        videoWidth = 370
      } else if (docWidth > 1330 && docWidth <= 1480) {
        videoWidth = 326
      } else if (docWidth <= 1330) {
        videoWidth = 290
      }
      const videoHeight = videoWidth / 400 * 228
      $this.StyleMessage.width = `${videoWidth}px`
      $this.StyleMessage.height = `${videoHeight}px`
    },
    // 重连webrtc
    restartWebRtc () {
      playoutAnalyze('playoutRightUpReStart', '/pop')
      if (!this.previewId) return
      this.axios({
        method: 'post',
        url: Outil.getUrl('/extra/restartWebRtc'),
        data: {
          programId: this.$BehaviorSyns.getProgramId(),
          webPreviewId: this.previewId
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: res.data.errorInfo
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errorInfo
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取预览状态
    getPreviewStatus () {
      const startTime = new Date().getTime()
      this.axios({
        method: 'post',
        url: Outil.getUrl('/program/runningEventStatus'),
        data: {
          startTime
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            this.NewLiveStatus = res.data.result
          } else if (res.data.errorCode == '80602014') {
            this.NewLiveStatus = {
              status: 0
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      }).catch(() => {})
    },
    // 计算分秒小时
    calculateInterval (time) {
      if (typeof time == 'number') {
        let hour = Math.floor(time / (60 * 60 * 1000))
        let minute = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000))
        let second = Math.floor((time % (60 * 1000)) / 1000)
        hour = hour ? `${hour}h` : ''
        minute = minute ? `${minute}m` : ''
        second = second ? `${second}s` : ''
        return hour + minute + second
      } else {
        return ''
      }
    },
    // 展示时间
    displayTime (startTime) {
      const startDate = Outil.getDateTime(new Date(startTime))
      const startDay =
        `${startDate.year}-${startDate.month}-${startDate.day}`
      return `${startDay} ${startDate.hour}:${startDate.min}:${startDate.s}`
    },
    // 预览画面
    previewVideo (x) {
      if (this.$refs.videoMp4) {
        this.srcObject = x
        this.$refs.videoMp4.srcObject = x
        this.$refs.videoMp4.muted = true
      }
    },
    // 静音按钮change
    changeIconStatus () {
      if (this.video2Muted) {
        playoutAnalyze('playoutRightVideoVolumeUp', '/pop')
      } else {
        playoutAnalyze('playoutRightVideoVolumeOff', '/pop')
      }
      this.$refs.videoMp4.muted = false
      this.video2Muted = !this.video2Muted
      this.$refs.videoMp4.muted = this.video2Muted
    },
    // 刷新pgmUrl
    ResetPgmUlr () {
      this.axios
        .post(Outil.getUrl('/singular/output2broadcast'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    // 获取Transcriber状态
    getTranscriber () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/transcriber/getTranscriber'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            this.transcriberStatus.transcriberShow = res.data.result.enableStatus
            this.transcriberStatus.isAuto = res.data.result.autoSense
            this.transcriberStatus.setOn = res.data.result.setOn
            // if(res.data.result)
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    clearCss () { },
    // 点击takeBreakSource按钮
    playSource () {
      playoutAnalyze('playoutTakeBreakingSource', '/pop')
      Bus.$emit('playSource')
    },
    // 点击takePlayList按钮
    stopSource () {
      playoutAnalyze('playoutTakePlayList', '/pop')
      Bus.$emit('stopSource')
    },
    // 点击takeNextEvent按钮
    takeNextEvent () {
      playoutAnalyze('playoutTakeNext', '/pop')
      Bus.$emit('takeNextEvent')
    },
    // 查看是否有设置的紧急播放视频
    ishaveEmergency () {
      return new Promise((resolve, reject) => {
        const params = {
          programId: this.$BehaviorSyns.getProgramId()
        }
        this.emergencySwitchLoading = true
        this.axios
          .post(Outil.getUrl('/event/emergency/query'), params)
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              if (res.data.result && res.data.result.id) {
                resolve(true)
              } else {
                resolve(false)
              }
            } else {
              this.emergencySwitchLoading = false
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.error(errorInfo)
            }
          }).catch(() => {})
      })
    },
    // 点击紧急播放按钮
    emergencySwitch () {
      if (this.emergencySwitchLoading) return
      this.ishaveEmergency().then(res => {
        if (res) {
          const params = {
            programId: this.$BehaviorSyns.getProgramId()
          }
          this.axios
            .post(Outil.getUrl('/event/emergency/switch'), params, { timeout: 60000 })
            .then((res) => {
              this.emergencySwitchLoading = false
              if (res.data.errorCode == '0x0') {
                this.$message.success('Success')
              } else {
                this.emergencySwitchLoading = false
                const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                this.$message.error(errorInfo)
              }
            }).catch((res) => {
              console.log(res)
            })
        } else {
          this.emergencySwitchLoading = false
          this.$message(this.$t('lang.setEmergency'))
        }
      }).catch(() => {})
    },
    // 打开紧急播放设置
    emergencySetting () {
      if (this.CloneDisabled.disableButton) return
      this.emergencySettingMess.show = true
    }
  },
  beforeDestroy () {
    console.warn('websocket-rightBox')
    if (this.$createWebsocket.pageRequest) {
      this.$createWebsocket.pageRequest('stop', ['getRunningSettingScte']) // 停止websocket
    }
    window.removeEventListener('keydown', this.monitorDownKey)
    window.removeEventListener('keyup', this.monitorUpKey)
    window.removeEventListener('focus', this.PageFocus)
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>
.calendar_right {
  width: 100%;
  height: 100%;
  float: right;
  .PreviewWrap{
    padding: 0 15px;
    .PreviewTop {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .Previewleft {
        width: 45%;
        display: flex;
        justify-content: flex-start;
      }
      .PreviewRight {
        width: 54%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .PreviewType {
        padding: 0 10px;
        height: 20px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        color: #dfdfdf;
        background: #ec5050;
        margin-right: 8px;
        white-space: nowrap;
      }
      .passthroughBlocker{
        img{
          width: 72px;
          height: 20px;
        }
      }
      .PreviewTypeScte {
        border: 1px solid #ec5050;
        background: #444;
        color: #ec5050;
      }

      .PreviewTitle {
        width: calc(100% - 90px);
        font-size: 12px;
        color: #dfdfdf;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
      .AudioOutput {
        min-width: 90px;
        text-align: center;
        .title {
          margin-top: 1px;
          margin-right: 5px;
        }
        .DisabledTitle{
          color: #999;
          opacity: .6;
        }
        .pushingIcon {
          display: inline-block;
          height: 20px;
          line-height: 20px;
          width: 40px;
          background: #33AB4F;
          border-radius: 10px;
          text-align: center;
          border: 1px solid #33AB4F;
          outline: none;
          vertical-align: middle;
          margin: 0!important;
        }
      }
      .restart{
        width: 30px;
        text-align: right;
        position: relative;
        i{
          font-size: 20px;
          color: #DFDFDF;
          cursor: pointer;
        }
        .RestartTip{
          position: absolute;
          top: -28px;
          right: -6px;
          width: 58px;
          height: 25px;
          background: #1B1B1B;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
          line-height: 25px;
          text-align: center;
          z-index: 2400;
          display: none;
        }
        .RestartTip::after{
          content: '';
          border: 8px solid #1B1B1B;
          position: absolute;
          bottom: -15px;
          right: 6px;
          border-color: #1B1B1B transparent transparent transparent;
        }
      }
      .restart:hover .RestartTip{
        display: block;
      }
    }
    .IconWrap{
      height: 30px;
      margin-top: 6px;
      // border-bottom: 2px solid #252525;
      // padding-right: 10px;
      padding-left: 10px;
      div{
        display: flex;
        justify-content: flex-end;
      }
      p{
        width: 20px;
        height: 20px;
        background: #67aa25;
        text-align: center;
        line-height: 20px;
        margin-right: 2px;
        border-radius: 3px;
      }
      .DCopyIcon{
        background: #67aa25;
        i {
          font-size: 12px;
          transform: scale(0.8);
        }
      }
      .CCIcon{
        background: #aaaaaa;
        i {
          font-size: 10px;
          transform: scale(0.7);
        }
      }
      .RcordIcon{
        background: #ec5050;
        i {
          font-size: 12px;
        }
      }
      .SCTEIcon{
        background: #f2f2f2;
        i {
          font-size: 12px
        }
      }
      i{
        color: #252525;
      }
    }
    .video {
      // border-bottom: 2px solid #000;
      display: flex;
      padding-left: 50px;
      padding-bottom: 10px;
      justify-content: center;
      .rightVolume{
        display: flex;
        flex-direction: column;
        .audioOperate{
          text-align: left;
          ::v-deep .el-dropdown{
            .el-icon-arrow-down{
              color: #fff;
            }
          }
        }

      }
      #videoMp4 {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: #333;
      }
      .singularIframe {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
      .iconfont {
        // position: absolute;
        // right: 20px;
        // bottom: 10px;
        z-index: 2;
        width: 20px;
        height: 20px;
        padding-top: 3px
      }
      #videoMp8 {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
      }
      .videoOption {
        width: 100%;
        height: 40px;
      }
      img {
        width: 0;
        height: 0;
      }
      .openTranscriber{
        color: #EC5050;
        position: absolute;
        top: 5px;
        left: -10px;
      }
      .buffer{
        color: #EC5050;
        position: absolute;
        top: 30px;
        left: -10px;
        white-space: nowrap; /* 防止换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .circle{
        display: inline-block;
        width: 10px;
        height: 10px;
       background-color:#EC5050;
        border-radius: 50%;
         position: absolute;
        // top: 5px;
        // left: -10px;
      }
    }
  }
  .detail {
    padding: 16px;
    .title {
      padding-bottom: 16px;
      text-align: left;
    }
    .type_options {
      li {
        width: 79px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        color: #666;
      }
      li.active {
        background: rgba(39, 40, 41, 1);
        color: #33ab4f;
      }
    }
    .person_options::-webkit-scrollbar {
      /*滚动条整体样式*/
      height: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    }
    .person_options {
      // width: auto;
      overflow-x: scroll;
      white-space: nowrap;
      margin-bottom: 15px;
      li {
        margin-right: 8px;
        width: 80px;
        display: inline-block;
      }
      .img {
        width: 80px;
        height: 80px;
        border: 1px solid #666;
      }
      .person_name {
        height: 35px;
        font-size: 12px;
        color: rgba(204, 204, 204, 1);
        margin-top: 4px;
        white-space: normal;
      }
    }
  }
  .ButtonOperation {
    border-bottom: 2px solid #555555;
    padding: 0  0  12px 38px;
    display: flex;
    flex-wrap: wrap;
        border-top: 2px solid #252525;

    .Btn {
      display: flex;
      height: 32px;
      line-height: 32px;
      background: none;
      border: 1px solid #8d8d8d;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap !important;
      text-align: center;
      border-radius: 2px;
      margin: 12px 15px 0 0;
      padding: 0px 20px;
      ::v-deep i{
        line-height: 32px;
      }
      ::v-deep span {
        font-size: 12px;
        float: left;
        width: 90%;
      }
    }
    ::v-deep span:first-child {
      margin-left: -10px;
    }
    .is-loading{
      justify-content: center;
    ::v-deep span{
        display: none;
      }
    }
    .is-disabled{
      color: #999;
      opacity: .6;
    }
    i{
      align-self: center;
      padding-top: 15px;
    }
  }
  .OverlayInfo{
    height: calc(100% - 338px);
  }
  .optionDiv {
    width: 100%;
    height: 470px;
    overflow-y: auto;
    margin: 0;
    ::v-deep .el-switch__core {
      width: 57px !important;
    }
    .swtichBox {
      width: 100%;
      height: 60px;
      border-bottom: 2px solid #555555;
      cursor: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .uploadImg {
        height: 40px;
        display: flex;
        ::v-deep .addBtn {
          width: 20px;
          height: 40px;
          float: right;
          padding: 0;
          background: #333;
          border-radius: 2px;
        }
        .setBtn {
          width: 112px;
          height: 40px;
          background: #252525;
          line-height: 40px;
          border-radius: 2px;
          cursor: pointer;
        }
        .el-icon-arrow-down {
          width: 20px;
          height: 40px;
          margin: 0;
          line-height: 40px;
          cursor: pointer;
          background: #333333;
        }
        img{
          object-fit: contain;
        }
      }
      .SetCrawl {
        width: 171px;
        display: flex;
        justify-content: space-between;
        i {
          color: #999999;
        }
      }
      .switchLoading{
        position: relative;
        .pushingIcon {
          position: absolute;
          top: 0px;
          left: 0px;
          display: inline-block;
          height: 25px;
          width: 57px;
          background-color: rgba(0, 0, 0, .8);
          border-radius: 10px;
          text-align: center;
          i{
            font-size: 17px;
          }
        }
      }
    }
    ::v-deep .ScteOperation {
      .ScteTitle {
        width: 92px;
        height: 17px;
        font-size: 14px;
        color: #ffffff;
        line-height: 17px;
        margin-top: 11px;
        text-align: left;
      }
      // .ScteContent {
      //   padding-left: 25px;
      //   padding-right: 10px;
      //   .BreakUnderplay{
      //     display: flex;
      //     align-items: center;
      //     justify-content: space-between;
      //     border-bottom: 1px solid #555555;
      //     padding:10px 0px 9px;
      //     text-align: left;
      //     p{
      //       width: 80px;
      //       margin: 0;
      //     }
      //     .SelectSwitch{
      //       width: 252px;
      //       display: flex;
      //       justify-content: space-between;
      //       align-items: center;
      //       .el-select {
      //         width: 152px;
      //         .el-scrollbar__wrap{
      //           width: 180px;
      //         }
      //         .el-input__inner {
      //           background: #333333;
      //           height: 28px;
      //         }
      //       }
      //       .switchLoading{
      //         position: relative;
      //         .pushingIcon {
      //           position: absolute;
      //           top: 0px;
      //           left: 0px;
      //           display: inline-block;
      //           height: 20px;
      //           width: 57px;
      //           background-color: rgba(0, 0, 0, .8);
      //           border-radius: 10px;
      //           text-align: center;
      //           i{
      //             font-size: 17px;
      //           }
      //         }
      //       }
      //     }
      //   }
      //   .ScteSelete {
      //     display: flex;
      //     justify-content: space-between;
      //     align-items: center;
      //     margin-top: 12px;
      //     p {
      //       height: 17px;
      //       font-size: 14px;
      //       color: #dfdfdf;
      //       line-height: 17px;
      //       margin: 0;
      //     }
      //     .el-select {
      //       width: 252px;
      //       .el-input__inner {
      //         background: #333333;
      //         height: 28px;
      //       }
      //     }
      //   }
      //   .autoSlider {
      //     position: relative;
      //     width: 252px;
      //     margin-left: auto;
      //     margin-bottom: 19px;
      //     margin-top: 15px;

      //     .el-slider__runway {
      //       margin-right: 90px;
      //       background: #585b5d;
      //       margin-top: 12px;

      //       .el-slider__marks {
      //         .el-slider__marks-text {
      //           margin-top: -25px;
      //           width: 43px;
      //         }

      //         .el-slider__marks-text:nth-child(1) {
      //           width: 30px;
      //         }
      //       }

      //       .el-slider__marks-stop {
      //         display: none;
      //       }
      //     }

      //     .el-slider__input {
      //       width: 79px;
      //       height: 28px;
      //       background: #313436;

      //       .el-input-number__decrease,
      //       .el-input-number__increase {
      //         display: none;
      //       }

      //       .el-input input {
      //         width: 65px;
      //         height: 28px;
      //         background: rgba(49, 52, 54, 1);
      //         border: 1px solid rgba(49, 52, 54, 1);
      //         color: #fff;
      //         text-align: left;
      //         padding-left: 4px;
      //         padding-right: 0px;
      //       }
      //     }

      //     .unit {
      //       position: absolute;
      //       right: 8px;
      //       top: 8px;
      //       font-size: 14px;
      //       color: #979da3;
      //     }
      //   }
      //   .signalSelect {
      //     display: flex;
      //     justify-content: flex-end;
      //     margin-top: 16px;
      //     .el-select {
      //       width: 252px;
      //       .el-input__inner {
      //         background: #333333;
      //         height: 28px;
      //       }
      //     }
      //     .el-select-dropdown__item {
      //       text-align: left;
      //       width: 252px;
      //     }
      //   }
      //   .ScteButton {
      //     margin-top: 12px;
      //     .CustomTime{
      //       position: relative;
      //       .el-input{
      //         margin-bottom: 20px;
      //         input{
      //           height: 30px;
      //           border: none;
      //           background: #333333;
      //           padding-right: 70px;
      //         }
      //       }
      //       span{
      //         position: absolute;
      //         right: 10px;
      //         top: 3px;
      //       }
      //     }
      //     .button {
      //       width: 100%;
      //       height: 32px;
      //       border-radius: 2px;
      //       text-align: center;
      //       line-height: 32px;
      //     }
      //     .ScteStart {
      //       background: #33ab4f;
      //     }
      //     .ScteStop {
      //       background: #ec5050;
      //     }
      //   }
      //   .ScteHistoryList {
      //     margin-top: 11px;
      //     padding-top: 15px;
      //     border-top: 2px solid #555555;
      //     .ScteHistory {
      //       display: flex;
      //       justify-content: space-between;
      //       align-items: center;
      //       margin-bottom: 16px;
      //       .left {
      //         text-align: left;
      //         .name {
      //           color: #dfdfdf;
      //         }
      //         .time {
      //           color: #888888;
      //           margin-top: 3px;
      //         }
      //       }
      //       .right {
      //         color: #dbdbdb;
      //         span {
      //           color: #888888;
      //         }
      //       }
      //     }
      //   }
      // }
    }
  }
  .optionDiv::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 1681px) {
  .calendar_right {
    .OverlayInfo{
      height: calc(100% - 380px);
    }
  }
}
</style>
<style lang='less'>
  .volume{
    .el-dropdown-menu__item{
      .el-icon-check{
        color: #33ab4f;
      }
      .el-icon-close{
        opacity: 0;
      }
    }
  }
</style>
